import styled from "styled-components";

export const StyledPaymentItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    &:not(&:last-child) {
        padding-bottom: 10px;
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    }
`;
